export class BuyerID{
    employeeId?:number;
    constructor(employeeId?:number)
    {this.employeeId=employeeId}
}